import { MRT_RowData, MRT_TableInstance } from 'mantine-react-table';
import { useEffect, useRef } from 'react';

/** The DOM id a table row must carry for `useRevealExpandedRow` to find it. */
export const revealRowElementId = (rowId: string): string =>
  `reveal-row-${rowId}`;

export interface IUseRevealExpandedRowProps<T extends MRT_RowData> {
  table: MRT_TableInstance<T>;
  rowIds: string[];
  /** The rows are loaded and the table's saved sorting and paging are applied. */
  ready: boolean;
}

/**
 * Once per mount, when `ready`, scrolls the first of `rowIds` on the current
 * table page into view.
 */
export const useRevealExpandedRow = <T extends MRT_RowData>({
  table,
  rowIds,
  ready,
}: IUseRevealExpandedRowProps<T>) => {
  const doneRef = useRef(false);
  const rows = table.getRowModel().rows;

  useEffect(() => {
    if (doneRef.current || !ready) return;
    doneRef.current = true;

    const target = rows.find((row) => rowIds.includes(row.id));
    if (target) {
      document
        .getElementById(revealRowElementId(target.id))
        ?.scrollIntoView({ block: 'center' });
    }
  }, [ready, rows, rowIds]);
};
